import { parse as raw_parse } from "./formula_raw";

function execute_function(name, args) {
  switch (String(name).toLowerCase()) {
    case "abs":
      return Math.abs(args);
    case "pi":
      return Math.PI;
    case "sin":
      return Math.sin(args);
    case "cos":
      return Math.cos(args);
    case "tan":
      return Math.tan(args);
    case "cot":
      return 1 / Math.tan(args);
    case "asin":
      return Math.asin(args);
    case "acos":
      return Math.acos(args);
    case "atan":
      return Math.atan(args);
    case "acot":
      return Math.PI / 2 - Math.atan(args);
    case "sinh":
      return Math.sinh(args);
    case "cosh":
      return Math.cosh(args);
    case "tanh":
      return Math.tanh(args);
    case "coth":
      return 1 / Math.tanh(args);
    case "asinh":
      return Math.asinh(args);
    case "acosh":
      return Math.acosh(args);
    case "atanh":
      return Math.atanh(args);
    case "acoth":
      return Math.atanh(1 / args);
    case "atan2":
      return Math.atan(args[1] / args[0]);
    default:
      throw Error(`Unknown function: ${name}`);
  }
}

export function parse(expression, options) {
  return raw_parse(expression, {
    ...options,
    ...{ execute: execute_function },
  });
}
